import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const UPDATE_STATEMENT_OPERATION_ALWAYS_EDITABLE = gql`
  mutation UpdateStatementOperationAlwaysEditable(
    $statementOperationUuid: ID!
    $oldValueDate: Date!
    $impactsOverflow: Boolean!
    $comment: String
  ) {
    updateStatementOperationAlwaysEditable(
      statementOperationUuid: $statementOperationUuid
      oldValueDate: $oldValueDate
      impactsOverflow: $impactsOverflow
      comment: $comment
    ) {
      uuid
      impactsOverflow
      comment
    }
  }
`;

export const useUpdateStatementOperationAlwaysEditable = () => {
  const [updateStatementOperationAlwaysEditable, { loading, error, data }] = useMutation(UPDATE_STATEMENT_OPERATION_ALWAYS_EDITABLE);

  return {
    updateStatementOperationAlwaysEditable,
    loading,
    error,
    data: data?.updateStatementOperationAlwaysEditable,
  };
};

export default useUpdateStatementOperationAlwaysEditable;
